export default {
	setup: {
		title: "Configure os cadastros do seu terreiro",
		optionalTitle: "Cadastros opcionais",
		progress: "{done} de {total} cadastros essenciais",
		optionalProgress: "{done} de {total} cadastros opcionais",
		next: "Próximo passo: {item}",
		open: "Abrir",
		assistantHint: "Prefere ajuda? O assistente cadastra junto com você.",
		cta: "Configurar com o assistente",
		dismiss: "Dispensar",
		items: {
			medium: "Médiuns",
			linha_espiritual: "Linhas Espirituais",
			guia: "Guias",
			tipo_atendimento: "Tipos de Atendimento",
			tipo_ritual: "Tipos de Ritual",
			vincular_atendimento: "Vincular atendimento ao Tipo de Ritual",
			ritual: "Ritual",
			orixa: "Orixás",
			funcao: "Funções",
			etapa_jornada: "Etapas da Jornada",
		},
	},
	greeting: {
		morning: "Bom dia",
		afternoon: "Boa tarde",
		evening: "Boa noite",
	},
	activeRitual: {
		title: "Ritual em Andamento",
		noRituals: "Nenhum ritual ativo",
		noRitualsHint: "Abra um ritual para começar a chamar fichas.",
		viewAll: "Ver rituais",
		loadError: "Erro ao carregar rituais ativos",
		live: "Ao vivo",
		openSince: "Aberto às {time}",
		openSinceDate: "Aberto em {date}, {time}",
		elapsedHours: "há {hours}h{minutes}",
		elapsedMinutes: "há {minutes} min",
		elapsedDay: "há {days} dia",
		elapsedDays: "há {days} dias",
		progressLabel: "atendidas",
		pending: "Na fila",
		inProgress: "Em atendimento",
		completed: "Concluídas",
		noTickets: "Nenhuma ficha emitida ainda",
	},
	birthdayWidget: {
		title: "Aniversariantes",
		noBirthdays: "Nenhum aniversário próximo",
		today: "Hoje",
		tomorrow: "Amanhã",
		inDays: "Em {days} dias",
	},
	kpi: {
		consultants: "Consulentes",
		mediums: "Médiuns",
		tickets: "Fichas",
	},
	charts: {
		weeklyConsultants: "Novos Consulentes por Semana",
		monthlyPersons: "Consulentes por Mês",
		monthlyTickets: "Fichas por Mês",
		orixaDistribution: "Filhos por Orixá",
		noData: "Sem dados no período",
	},
	topConsultants: {
		title: "Consulentes Mais Ativos",
		noData: "Nenhum consulente com fichas",
	},
	upcomingRituals: {
		title: "Próximos Agendados",
		noRituals: "Nenhum ritual agendado",
		viewAll: "Ver todos",
	},
};
